import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "wo-qualification-container"
};
const _hoisted_2 = {
  class: "grid-container"
};
import { computed, onMounted, ref } from 'vue';
import store from '@/store';
import { ElInput, ElMessage } from 'element-plus';
import { request } from '@/manager/net_manager';
import QualificationCard from '@/components/Qualification/QualificationCard.vue';
import { isAdminType } from '@/tools/utils'; // refs

export default {
  __name: 'WOQualifications',

  setup(__props) {
    const form = ref({
      name: '',
      desc: ''
    }); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const worldOutlook = computed(() => store.state.world_outlook || null);
    const qualifications = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.qualifications ?? null;
    }); // functions

    const createQualification = () => {
      let parameters = form.value;
      parameters['world_outlook_id'] = worldOutlook.value.id;
      request('qualification/qualification_create/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        form.value = {
          name: '',
          desc: ''
        };
        store.dispatch('get_wo_qualifications');
      });
    };

    const updateQualification = item => {
      let parameters = {
        'qualification_id': item.id
      };
      parameters['updates'] = {
        'name': item.name,
        'desc': item.desc
      };
      request('qualification/qualification_update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.dispatch('get_wo_qualifications');
      });
    };

    const updateRoles = item => {
      let parameters = {
        'qualification_id': item.qualification_id
      };
      parameters['updates'] = {
        'roles': item.roles
      };
      request('qualification/qualification_update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.dispatch('get_wo_qualifications');
      });
    };

    const removeQualification = item => {
      let parameters = {
        'qualification_id': item.id
      };
      request('qualification/qualification_remove/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        store.dispatch('get_wo_qualifications');
      });
    }; // lifecycle


    onMounted(() => {
      if (!qualifications.value) {
        store.dispatch('get_wo_qualifications');
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_withDirectives(_createVNode(_component_el_row, {
        class: "qualification-operate-container"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInput), {
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
          placeholder: "资格名",
          type: "text",
          "show-word-limit": "",
          clearable: "",
          maxlength: "16"
        }, null, 8, ["modelValue"]), _createVNode(_unref(ElInput), {
          class: "qualification-desc",
          modelValue: form.value.desc,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.desc = $event),
          placeholder: "资格描述",
          type: "text",
          "show-word-limit": "",
          clearable: "",
          maxlength: "32"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          onClick: createQualification
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 添加 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 512), [[_vShow, _unref(isAdminType)(userType.value)]]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualifications.value, item => {
        return _openBlock(), _createBlock(QualificationCard, {
          key: item.id,
          qualification: item,
          onUpdateQualification: updateQualification,
          onUpdateRoles: updateRoles,
          onRemoveQualification: removeQualification
        }, null, 8, ["qualification"]);
      }), 128))])])]);
    };
  }

};